__turbopack_context__.v({
  "menu-item": "review-report-module-scss-module__GGj8zq__menu-item",
  "report-abuse-label": "review-report-module-scss-module__GGj8zq__report-abuse-label",
});
